import React from "react";
import { Route, RouteProps } from "react-router-dom";

interface PublicRouteProps extends RouteProps {
  component: React.ComponentType<RouteProps>;
}

export const PublicRoute: React.FC<PublicRouteProps> = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      localStorage.getItem("RwaAuthToken") ? (
        <Component {...props} />
      ) : (
        <Component {...props} />
      )
    }
  />
);